import { createStore } from 'vuex'

export default createStore({
  state: {
    name_x:"nakarin",
    isLoading:false,
  },
  mutations: {
    setLoading(state, isLoading){
      state.isLoading = isLoading
    }
  },
  actions: {
  },
  modules: {
  }
})
